import { store } from 'react-notifications-component';
import React from 'react';
export function ShowNotification(notificationType: any, message: any) {
  if(notificationType === "success") {
    store.addNotification({
        message: message,
        type: "success",
        container: 'center',
        animationIn: ["animate__animated", "animate__jackInTheBox"],
        animationOut: ["animate__animated", "animate__zoomOutUp"],
        dismiss: {
          duration: 6000,
          onScreen: true
        },        
        onRemoval: (id, removedBy) => {
            window.location.reload();
          }
      });
    }
  else {
    store.addNotification({
        message: <div><p>
          Hallo Vodafone-Kund:in,
        <br />es tut uns leid, aber bei der Verarbeitung deiner Anfrage auf dieser Webseite ist etwas schiefgegangen.
        <br />Alternativ kannst du auch bequem per Telefon dein Ticket stornieren, wieder öffnen sowie den aktuellen Status abfragen. 
        <br/>Melde dich unter 0221 4661 9100 und sage bei der Frage nach deinem Anliegen <i>"Störung"</i>.
        <br />Vielen Dank für dein Verständnis.
        <br />Freundliche Grüße
        <br />Dein Vodafone-Team
        </p> </div>,
        dismiss: {
            duration: 12000,
            onScreen: true,
            pauseOnHover:true
        },
        type: notificationType,
        container: 'center',
        animationIn: ["animate__animated", "animate__jackInTheBox"],
        animationOut: ["animate__animated", "animate__zoomOutUp"],
        width:500       
      });
    }
}
